import { ContainerLayerKind } from '../../../../shared/issuesV2/common';
import { CheckboxFilterGroup, FilterPanel } from '../../generic/Filter';

const FILTER_OPTIONS: Array<{ key: string, label: string }> = [
  { key: ContainerLayerKind.BaseLayer, label: 'Base Layer' },
  { key: ContainerLayerKind.OtherLayer, label: 'Other Layers' },
];

export type ContainerLayerFilterProps = {
  selectedOptions?: string[];
  onSelect: (key: string, selected: boolean) => void;
};

const ContainerLayerFilter = ({ selectedOptions, onSelect }: ContainerLayerFilterProps) =>
  <FilterPanel>
    <CheckboxFilterGroup
      title="Layer"
      options={FILTER_OPTIONS}
      selectedOptions={selectedOptions}
      onSelect={onSelect}
      testId="issues-container-layer-filters"
    />
  </FilterPanel>;

export default ContainerLayerFilter;
